import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import UiExperimentsAssignmentsPanel from './UiExperimentsAssignmentsPanel';
import UiExperimentsAnalyticsPanel from './UiExperimentsAnalyticsPanel';
import UiExperimentsFeedbackPanel from './UiExperimentsFeedbackPanel';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
  icon: {
    fontSize: 40,
    color: theme.palette.primary.main,
  },
  section: {
    marginBottom: theme.spacing(3),
  },
}));

export default function UiExperimentsPage({ userId }) {
  const classes = useStyles();
  const [refreshToken, setRefreshToken] = useState(0);

  return (
    <Container maxWidth="xl" className={classes.root}>
      <Box className={classes.header}>
        <TrackChangesIcon className={classes.icon} />
        <Box>
          <Typography variant="h4">UI Experiments</Typography>
          <Typography variant="body1" color="textSecondary">
            Target users for the v2 design rollout, send lobby prompts, and track adoption.
          </Typography>
        </Box>
      </Box>

      <Box className={classes.section}>
        <UiExperimentsAssignmentsPanel
          userId={userId}
          onChanged={() => setRefreshToken((value) => value + 1)}
        />
      </Box>

      <Box className={classes.section}>
        <UiExperimentsAnalyticsPanel userId={userId} refreshToken={refreshToken} />
      </Box>

      <Box className={classes.section}>
        <UiExperimentsFeedbackPanel userId={userId} refreshToken={refreshToken} />
      </Box>
    </Container>
  );
}

UiExperimentsPage.propTypes = {
  userId: PropTypes.string,
};
